module.exports = __webpack_public_path__ + "img/cliff-inner.97d66422.png";